export interface Polyline {
    polyline?: string;
    mobilePolyline?: string;
}

export interface IPolylineAttributes {
    color: string;
    width: string;
    points: string;
}

export interface IDynamicPolylineAttributes {
    color: string;
    width: string;
    transition: string;
    starting: string;
}

export const defaultPolylineAttribute: IPolylineAttributes = {
    color: 'black',
    width: '1',
    points: '0,1 1000,1'
};
